<template>
    <div class="query">
        <el-form :ref="ref" class="form" :model="value" :key="ref">
            <div v-for="(item,index) in list" :key="index" class="item">
                <template v-if="item.type == 'input'||item.type == 'number'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" style="width:215px" size="small"></el-input>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'textarea'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:550px'" size="small"></el-input>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'select'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" size="small" filterable>
                            <el-option
                            v-for="item in item.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'selectList'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-select v-model="value[item.name]" placeholder="请选择" multiple size="small" filterable>
                            <el-option
                            v-for="item in item.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'selectBtn'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-input v-model="value[item.name]" placeholder="请输入" :type="item.type" :rows="item.row" :style="'width:215px'" size="small" disabled></el-input>
                        <el-button type="primary" size="small" @click="item.btnFunction">{{item.btnName}}</el-button>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'address'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-cascader
                        size="small"
                        placeholder="请选择"
                        :options="regionData"
                        v-model="value[item.name]"
                        >
                        </el-cascader>
                    </el-form-item>
                </template>
                <template v-if="item.type == 'dateList'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>
                
                <template v-if="item.type == 'date'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>

                <template v-if="item.type == 'datetime'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-date-picker
                        size="small"
                        v-model="value[item.name]"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择日期"
                    >
                        </el-date-picker>
                    </el-form-item>
                </template>
                
                <template v-if="item.type == 'checkbox'">
                    <el-form-item :label="item.label" :label-width="labelWidth" :prop="item.name">
                        <el-checkbox-group v-model="value[item.name]">
                            <el-checkbox :label="row.label" v-for="(row,index) in item.options" :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </template>
            </div>
            <el-form-item :label-width="labelWidth">
                <div class="btns">
                    <el-button type="primary" size="small" @click="search()">查询</el-button>
                    <el-button type="warning" size="small" @click="reset()">重置</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { regionData , CodeToText } from "element-china-area-data";
    export default {
        computed: {
        },
        data() {
            return {
                regionData:regionData,
            }
        },
        props:{
            ref:{
                type: String,
                default: 'formList'
            },
            list:{
                type: Array,
                default: () => []
            },
            value: {
                type: Object,
                default: () => {}
            },
            labelWidth:{
                type: String,
                default: '150px'
            },
            search:{
                type: Function,
                default: () => {
                }
            },
            reset:{
                type: Function,
                default: () => {
                }
            },
        },
        
        watch: {
            
        },
        created() {

        },
        mounted() {
            this.list = this.list;
        },
        methods: {
            resetFields() {
                console.log(this.ref);
                this.$refs[this.ref].resetFields();
            }
        }

    }
</script>

<style lang="scss" scoped>
    .form{
        display: flex;
        flex-wrap: wrap;
        .item{
            display: flex;
        }
        .btns{
            width: 215px;
            // display: flex;
            // flex-direction: row-reverse;
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #606266;
    }
</style>